import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./Login.css";

export default function FinishSignIn() {
  const { completeSignInFromLink } = useAuth();
  const navigate = useNavigate();
  const [needsEmail, setNeedsEmail] = useState(false);
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | null>(null);
  const ran = useRef(false);

  async function finish(fallbackEmail?: string) {
    try {
      await completeSignInFromLink(window.location.href, fallbackEmail);
      navigate("/tests", { replace: true });
    } catch (err: unknown) {
      const code = (err as Error)?.message;
      if (code === "email-required") {
        setNeedsEmail(true);
      } else {
        console.error(err);
        setError(
          "El enlace no es válido o ha caducado. Solicita uno nuevo.",
        );
      }
    }
  }

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    finish();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="login">
      <div className="login__card card">
        <img className="login__logo" src="/logo-horse.png" alt="Equi for All" />
        {needsEmail ? (
          <>
            <h1 className="login__title">Confirma tu correo</h1>
            <p className="login__text">
              Para completar el acceso, confirma el correo donde recibiste el
              enlace.
            </p>
            <form
              className="login__form"
              onSubmit={(e) => {
                e.preventDefault();
                setError(null);
                finish(email);
              }}
            >
              <input
                className="login__input"
                type="email"
                placeholder="tu@correo.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button className="btn btn--block" type="submit">
                Acceder
              </button>
            </form>
          </>
        ) : error ? (
          <>
            <h1 className="login__title">Enlace no válido</h1>
            <p className="login__text">{error}</p>
            <button className="btn" onClick={() => navigate("/login")}>
              Volver a iniciar sesión
            </button>
          </>
        ) : (
          <>
            <div className="spinner" style={{ margin: "8px auto 16px" }} />
            <p className="login__text">Accediendo…</p>
          </>
        )}
      </div>
    </div>
  );
}
